
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class BaseMenuButton extends Vue {
  @Prop() private disabled!: boolean
}
